import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ActionSheetController, ModalController, PopoverController } from '@ionic/angular';
import { AlertService } from 'src/app/service/ionic/alert.service';
import { NavService } from 'src/app/service/ionic/nav.service';
@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<unknown> {
  constructor(
    private alert: AlertService,
    private popver: PopoverController,
    private modal: ModalController,
    private actionSheet: ActionSheetController,
    private navCtrl: NavService
  ) {}
  async canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if(this.navCtrl.force) {
      this.navCtrl.force = false;
      return true;
    }

    const pwaEl = document.getElementsByTagName('pwa-action-sheet')?.[0];
    if(pwaEl) {
      pwaEl.remove();
      return false;
    } 

    const tops = await Promise.all([
      this.alert.getTop(),
      this.modal.getTop(),
      this.popver.getTop()
    ])
    for(let i = 0; i < tops.length; i++) {
      const top = tops[i];
      if(top) {
        await top.dismiss();
        return false;
      }
    }
    return true;
  }
  
}
